var map = {
	"./Afganistan.jpg": 78630,
	"./Aland Islas.jpg": 80778,
	"./Albania.jpg": 75065,
	"./Alemania.jpg": 65400,
	"./Andorra.jpg": 75241,
	"./Angola.jpg": 70445,
	"./Anguila.jpg": 84732,
	"./Antartida.jpg": 86506,
	"./Antigua y Barbuda.jpg": 21883,
	"./Arabia Saudita.jpg": 6970,
	"./Argelia.jpg": 28714,
	"./Argentina.jpg": 20567,
	"./Armenia.jpg": 84330,
	"./Aruba.jpg": 50840,
	"./Australia.jpg": 8744,
	"./Austria.jpg": 97356,
	"./Azerbaiyan.jpg": 48673,
	"./Bahamas.jpg": 24070,
	"./Banglades.jpg": 72733,
	"./Barbados.jpg": 57972,
	"./Barein.jpg": 40950,
	"./Belgica.jpg": 60106,
	"./Belice.jpg": 52377,
	"./Benin.jpg": 75019,
	"./Bermudas.jpg": 67763,
	"./Bhutan.jpg": 35715,
	"./Bielorrusia.jpg": 16808,
	"./Bolivia.jpg": 9712,
	"./Bonaire, San Eustaquio y Saba.jpg": 24984,
	"./Bosnia y Herzegovina.jpg": 14009,
	"./Botsuana.jpg": 49660,
	"./Bouvet, Isla.jpg": 92819,
	"./Brasil.jpg": 78711,
	"./Brunei Darussalam.jpg": 55016,
	"./Burkina Faso.jpg": 52142,
	"./Burundi.jpg": 62067,
	"./Cabo Verde.jpg": 50168,
	"./Caiman, (las) Islas.jpg": 65778,
	"./Camboya.jpg": 56296,
	"./Camerun.jpg": 34676,
	"./Canada.jpg": 34331,
	"./Chad.jpg": 30973,
	"./Chile.jpg": 55881,
	"./China.jpg": 94507,
	"./Chipre.jpg": 31016,
	"./Christmas, Isla.jpg": 27863,
	"./Colombia.jpg": 43893,
	"./Comoras.jpg": 47845,
	"./Congo.jpg": 2257,
	"./Cook, Islas.jpg": 79173,
	"./Corea del Norte.jpg": 33825,
	"./Corea del Sur.jpg": 51299,
	"./Costa Rica.jpg": 55149,
	"./Costa de Marfil.jpg": 98057,
	"./Croacia.jpg": 41983,
	"./Cuba.jpg": 50278,
	"./Curazao.jpg": 93143,
	"./Dinamarca.jpg": 33371,
	"./Dominica.jpg": 414,
	"./Ecuador.jpg": 98552,
	"./Egipto.jpg": 16467,
	"./El Salvador.jpg": 63322,
	"./Emiratos Arabes Unidos.jpg": 67075,
	"./Eritrea.jpg": 76446,
	"./Escocia.jpg": 36974,
	"./Eslovaquia.jpg": 9889,
	"./Eslovenia.jpg": 65337,
	"./España.jpg": 50866,
	"./Estados Unidos.jpg": 95481,
	"./Estonia.jpg": 15452,
	"./Eswatini.jpg": 65195,
	"./Etiopia.jpg": 35542,
	"./Filipinas.jpg": 3953,
	"./Finlandia.jpg": 11906,
	"./Fiyi.jpg": 9787,
	"./Francia.jpg": 48395,
	"./Gabon.jpg": 44401,
	"./Gales.jpg": 2512,
	"./Gambia.jpg": 69028,
	"./Georgia del Sur (la) y las Islas Sandwich del Sur.jpg": 45396,
	"./Georgia.jpg": 81970,
	"./Ghana.jpg": 1475,
	"./Gibraltar.jpg": 8813,
	"./Granada.jpg": 55735,
	"./Grecia.jpg": 1237,
	"./Groenlandia.jpg": 94504,
	"./Guadalupe.jpg": 24028,
	"./Guam.jpg": 38629,
	"./Guatemala.jpg": 67274,
	"./Guayana Francesa.jpg": 23374,
	"./Guernsey.jpg": 67230,
	"./Guinea Ecuatorial.jpg": 35092,
	"./Guinea-Bissau.jpg": 2947,
	"./Guinea.jpg": 1769,
	"./Guyana.jpg": 340,
	"./Haiti.jpg": 67989,
	"./Heard (Isla) e Islas McDonald.jpg": 83811,
	"./Honduras.jpg": 3668,
	"./Hong Kong.jpg": 60753,
	"./Hungria.jpg": 72063,
	"./India.jpg": 45470,
	"./Indonesia.jpg": 69962,
	"./Inglaterra.jpg": 94306,
	"./Iran.jpg": 17609,
	"./Iraq.jpg": 29354,
	"./Irlanda del Norte.jpg": 58201,
	"./Irlanda.jpg": 48583,
	"./Isla de Man.jpg": 84183,
	"./Isla de San Martin.jpg": 22234,
	"./Islandia.jpg": 47589,
	"./Islas Feroe.jpg": 82366,
	"./Islas menores alejadas de Estados Unidos.jpg": 79649,
	"./Israel.jpg": 62695,
	"./Italia.jpg": 60871,
	"./Jamaica.jpg": 78557,
	"./Japon.jpg": 18249,
	"./Jersey.jpg": 55240,
	"./Jordania.jpg": 37445,
	"./Kazajistan.jpg": 48631,
	"./Kenia.jpg": 69935,
	"./Kirguistan.jpg": 87732,
	"./Kiribati.jpg": 72173,
	"./Kosovo.jpg": 53353,
	"./Kuwait.jpg": 810,
	"./Lao, (la) Republica Democratica Popular.jpg": 82382,
	"./Lesoto.jpg": 85205,
	"./Letonia.jpg": 47136,
	"./Libano.jpg": 6368,
	"./Liberia.jpg": 46541,
	"./Libia.jpg": 42723,
	"./Liechtenstein.jpg": 65575,
	"./Lituania.jpg": 76482,
	"./Luxemburgo.jpg": 30041,
	"./Macao.jpg": 19750,
	"./Macedonia del Norte.jpg": 88527,
	"./Madagascar.jpg": 87623,
	"./Malasia.jpg": 9821,
	"./Malawi.jpg": 86005,
	"./Maldivas.jpg": 4443,
	"./Mali.jpg": 52942,
	"./Malta.jpg": 75584,
	"./Malvinas [Falkland], (las) Islas.jpg": 94312,
	"./Marianas Septentrionales, (las) Islas.jpg": 54903,
	"./Marruecos.jpg": 50003,
	"./Marshall, (las) Islas.jpg": 74007,
	"./Martinica.jpg": 55528,
	"./Mauricio.jpg": 89388,
	"./Mauritania.jpg": 24794,
	"./Mayotte.jpg": 49343,
	"./Mexico.jpg": 99364,
	"./Micronesia (Estados Federados de).jpg": 7691,
	"./Moldova (la Republica de).jpg": 15059,
	"./Mongolia.jpg": 12293,
	"./Montenegro.jpg": 70395,
	"./Montserrat.jpg": 45802,
	"./Mozambique.jpg": 58134,
	"./Myanmar.jpg": 12516,
	"./Namibia.jpg": 21001,
	"./Nauru.jpg": 95099,
	"./Nepal.jpg": 6622,
	"./Nicaragua.jpg": 41311,
	"./Niger.jpg": 60128,
	"./Nigeria.jpg": 14317,
	"./Niue.jpg": 63215,
	"./Norfolk, Isla.jpg": 31607,
	"./Noruega.jpg": 62601,
	"./Nueva Caledonia.jpg": 5464,
	"./Nueva Zelanda.jpg": 42125,
	"./Oman.jpg": 28420,
	"./Paises Bajos.jpg": 7090,
	"./Pakistan.jpg": 77758,
	"./Palau.jpg": 74089,
	"./Palestina.jpg": 94751,
	"./Panama.jpg": 34305,
	"./Papua Nueva Guinea.jpg": 20408,
	"./Paraguay.jpg": 4918,
	"./Peru.jpg": 38004,
	"./Pitcairn.jpg": 58767,
	"./Polonia.jpg": 29093,
	"./Portugal.jpg": 80401,
	"./Puerto Rico.jpg": 59554,
	"./Qatar.jpg": 85404,
	"./R.D. Congo.jpg": 84038,
	"./Reino Unido.jpg": 66438,
	"./Rep. Dominicana.jpg": 7790,
	"./Republica Arabe Siria.jpg": 64394,
	"./Republica Centroafricana.jpg": 53073,
	"./Republica Checa.jpg": 28475,
	"./Reunion.jpg": 2234,
	"./Ruanda.jpg": 63272,
	"./Rumania.jpg": 7481,
	"./Rusia.jpg": 93541,
	"./Sahara Occidental.jpg": 51651,
	"./Salomon, Islas.jpg": 96995,
	"./Samoa Americana.jpg": 44833,
	"./Samoa.jpg": 56380,
	"./San Barthelemy.jpg": 96836,
	"./San Cristobal y Nieves.jpg": 96384,
	"./San Marino.jpg": 91049,
	"./San Martin (parte francesa).jpg": 94098,
	"./San Pedro y Miquelon.jpg": 69902,
	"./San Vicente y las Granadinas.jpg": 30751,
	"./Santa Elena, Ascension y Tristan de Acuña.jpg": 37470,
	"./Santa Lucia.jpg": 88398,
	"./Santa Sede.jpg": 24261,
	"./Santo Tome y Principe.jpg": 9833,
	"./Senegal.jpg": 41597,
	"./Serbia.jpg": 90304,
	"./Seychelles.jpg": 28778,
	"./Sierra Leona.jpg": 59761,
	"./Singapur.jpg": 85951,
	"./Somalia.jpg": 32139,
	"./Sri Lanka.jpg": 38123,
	"./Sudafrica.jpg": 54466,
	"./Sudan del Sur.jpg": 39759,
	"./Sudan.jpg": 36562,
	"./Suecia.jpg": 46187,
	"./Suiza.jpg": 39885,
	"./Surinam.jpg": 35658,
	"./Svalbard y Jan Mayen.jpg": 71314,
	"./Tahiti.jpg": 72164,
	"./Tailandia.jpg": 80439,
	"./Taiwan.jpg": 22975,
	"./Tanzania.jpg": 99467,
	"./Tayikistan.jpg": 77362,
	"./Territorio Britanico del Oceano Indico (el).jpg": 81931,
	"./Tierras Australes Francesas.jpg": 40055,
	"./Timor-Leste.jpg": 23529,
	"./Togo.jpg": 34383,
	"./Tokelau.jpg": 93398,
	"./Tonga.jpg": 21459,
	"./Trinidad y Tobago.jpg": 59943,
	"./Tunez.jpg": 90183,
	"./Turcas y Caicos, Islas.jpg": 27534,
	"./Turkmenistan.jpg": 60186,
	"./Turquia.jpg": 17649,
	"./Tuvalu.jpg": 133,
	"./Ucrania.jpg": 59538,
	"./Uganda.jpg": 86141,
	"./Uruguay.jpg": 53325,
	"./Uzbekistan.jpg": 9332,
	"./Vanuatu.jpg": 67481,
	"./Venezuela.jpg": 86102,
	"./Vietnam.jpg": 58719,
	"./Virgenes Britanicas, Islas.jpg": 82730,
	"./Virgenes de los Estados Unidos, Islas.jpg": 59163,
	"./Wallis y Futuna.jpg": 92321,
	"./Yemen.jpg": 99829,
	"./Yibuti.jpg": 37552,
	"./Zambia.jpg": 93612,
	"./Zimbabwe.jpg": 60799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65169;